import { Application, Container } from '@tencent/alloy-renderer';
import { RenderArea } from './render-area';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import imageCache from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-graphic/fill-style/image-cache';
import { IRenderProps } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-entry/edit-pc/stable-layer/stable-layer.interface';

/**
 * 背景实例
 * 一个母版实例对应一个canvas节点
 */
export class BackgroundService {
    private scale: number;
    private renderArea: RenderArea;
    private slideModel: ISlideModel;
    private getApplication: () => Application;
    private handleStableLayerUpdate: (props: Partial<IRenderProps>) => void;

    public constructor(
        scale = 1,
        slideModel: ISlideModel,
        renderStableLayer: (props: Partial<IRenderProps>) => void,
        getApplication: () => Application,
    ) {
        this.slideModel = slideModel;
        this.scale = scale;
        this.slideModel = slideModel;
        this.handleStableLayerUpdate = renderStableLayer;
        this.getApplication = getApplication;

        this.addListener();
        this.renderArea = new RenderArea(
            this.scale,
            this.slideModel,
            this.handleStableLayerUpdate,
        );
    }

    public removeListener = () => {
        this.slideModel.changeSetEngine.removeChangesetObserver(this.handleSlideModelChange);
    };

    /**
     * 获取这个母版的component
     */
    public getComponent = (): Container => this.renderArea;

    public updateWithData(scale: number): void {
        this.scale = scale;
        this.renderArea.updateInfo(scale);
    }

    public renderBackgroundComponent = (): void => {
        this.renderArea.renderBackgroundComponent();
    };

    // 确保渲染完成
    public async ensureRenderComplete(waitForRender = false): Promise<void> {
        // 确保图片资源加载完成
        const imgLoadComplete = imageCache.promiseModelTreeImgLoaded(this.slideModel, false);
        await imgLoadComplete;
        // 强制同步渲染一次
        waitForRender && this.getApplication?.().render();
    }

    private handleSlideModelChange = () => {
        this.renderBackgroundComponent();
    };

    private addListener = () => {
        this.slideModel.changeSetEngine.addChangesetObserver(this.handleSlideModelChange);
    };
}
